module.exports = __webpack_public_path__ + "img/education-materials-download.1166d3fa.svg";